import React from 'react'

const Paragraph = ({ children }) =>{
    return (<p>{ children}</p>)
}

export default Paragraph;

